import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Auth',
  setup(__props, { expose: __expose }) {
  __expose();

const isResetForm = ref(false)

const router = useRouter()
const route = useRoute()
// const props = defineProps(['paymentPage', 'mainPage'])


const __returned__ = { isResetForm, router, route, ref, get useRouter() { return useRouter }, get useRoute() { return useRoute } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})